<section class="maintenance-tab">
  <!-- SKELETON LOADING -->
  <div class="maintenance-loading" *ngIf="loading">
    <p-skeleton height="56px" borderRadius="10px" styleClass="mb-3" />
    <p-skeleton height="120px" borderRadius="12px" styleClass="mb-3" />
    <p-skeleton height="24px" width="40%" styleClass="mb-4" />
    <p-skeleton height="200px" borderRadius="12px" />
  </div>

  <ng-container *ngIf="!loading">
    <!-- BANNER DE ALERTA CASO O EQUIPAMENTO ESTEJA INATIVO -->
    <div class="inactive-warning-banner" *ngIf="isEquipamentoInativo()">
      <i class="ri-error-warning-line"></i>
      <span>Este equipamento encontra-se <strong>Inativo</strong>. O agendamento e edição de manutenções estão desativados.</span>
    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         1. BLOCO DE ÚLTIMA REVISÃO (No topo, se existir manutenção concluída)
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="ultima-revisao-banner" *ngIf="ultimaRevisao">
      <div class="urb-icon">
        <i class="ri-checkbox-circle-fill"></i>
      </div>
      <div class="urb-content">
        <div class="urb-title">
          Última revisão: <strong>{{ formatDate(ultimaRevisao.dataManutencao) }}</strong>
        </div>
        <div class="urb-meta">
          <span *ngIf="ultimaRevisao.quilometragemOuHorasUso">
            Km {{ ultimaRevisao.quilometragemOuHorasUso | number:'1.0-0' }}
          </span>
          <span class="sep" *ngIf="ultimaRevisao.quilometragemOuHorasUso">·</span>
          <span>Custo {{ formatKz(ultimaRevisao.custo) }}</span>
          <span class="sep" *ngIf="getOficina(ultimaRevisao)">·</span>
          <span *ngIf="getOficina(ultimaRevisao)">{{ getOficina(ultimaRevisao) }}</span>
        </div>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         2. BLOCO DE MANUTENÇÕES EM CURSO (ou Próxima Revisão se vazio)
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="em-curso-section">
      <div class="section-title-row">
        <div class="section-title">
          <h4>Manutenções em curso</h4>
          <span class="badge-count" *ngIf="manutencoesEmCurso.length > 0">
            {{ manutencoesEmCurso.length }}
          </span>
        </div>
      </div>

      <!-- Lista de manutenções em aberto -->
      <div class="em-curso-list" *ngIf="manutencoesEmCurso.length > 0">
        <div class="em-curso-card" *ngFor="let item of manutencoesEmCurso">
          <div class="ecc-main">
            <div class="ecc-header">
              <strong class="ecc-title">
                {{ getTipoLabel(item.manutencaoTipoEnum) }} —
                {{ item.descricaoServico || '#' + item.id }}
              </strong>
            </div>
            <div class="ecc-subline">
              <span *ngIf="getOficina(item)">{{ getOficina(item) }} · </span>
              <span>{{ formatKz(item.custo) }}</span>
              <span *ngIf="item.quilometragemOuHorasUso">
                · {{ item.quilometragemOuHorasUso | number:'1.0-0' }} km
              </span>
              <span *ngIf="item.dataManutencao">
                · aberta em {{ formatDate(item.dataManutencao) }}
              </span>
              <span *ngIf="item.observacoes" class="ecc-obs">
                · {{ getObservacoesLimpas(item) }}
              </span>
            </div>
          </div>

          <div class="ecc-actions">
            <button
              type="button"
              class="btn-concluir-action"
              (click)="openConcluir(item)"
              [disabled]="isEquipamentoInativo()"
              [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : 'Concluir esta intervenção'"
              tooltipPosition="top"
            >
              <i class="ri-check-line"></i> Concluir
            </button>

            <button
              type="button"
              class="btn-icon-subtle"
              (click)="openEdit(item)"
              [disabled]="isEquipamentoInativo()"
              [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : 'Editar dados estimados'"
              tooltipPosition="top"
            >
              <i class="ri-pencil-line"></i>
            </button>

            <button
              type="button"
              class="btn-icon-subtle danger"
              (click)="confirmDelete(item)"
              [disabled]="isEquipamentoInativo()"
              [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : 'Cancelar/Eliminar'"
              tooltipPosition="top"
            >
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Quando não houver nenhuma manutenção em curso: exibe Próxima Revisão prevista -->
      <div class="proxima-revisao-card" *ngIf="manutencoesEmCurso.length === 0">
        <div class="prc-left">
          <div class="prc-icon">
            <i class="ri-calendar-check-line"></i>
          </div>
          <div class="prc-info">
            <span class="prc-eyebrow">Sem intervenções em curso</span>
            <strong class="prc-title" *ngIf="proximaRevisaoTexto">
              Próxima revisão prevista: {{ proximaRevisaoTexto }}
            </strong>
            <strong class="prc-title" *ngIf="!proximaRevisaoTexto">
              Nenhuma intervenção em aberto ou agendada
            </strong>
          </div>
        </div>
        <button
          type="button"
          class="btn-web-secondary sm"
          (click)="openCreate()"
          [disabled]="isEquipamentoInativo()"
          [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : ''"
          tooltipPosition="top"
        >
          <i class="ri-add-line"></i> Agendar Revisão / Manutenção
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         3. LINHA DE RESUMO (Discreta, sem peso visual de cards separados)
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="maintenance-summary-line">
      <span class="msl-item">
        <i class="ri-tools-line"></i>
        <span>
          <strong>{{ totalIntervencoes }}</strong>
          {{ totalIntervencoes === 1 ? 'intervenção' : 'intervenções' }}
        </span>
      </span>
      <span class="msl-sep">•</span>
      <span class="msl-item">
        <i class="ri-money-dollar-circle-line"></i>
        <span>Custo acumulado: <strong>{{ formatKz(totalCost) }}</strong></span>
      </span>
    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         4. HISTÓRICO DE MANUTENÇÃO (Timeline de intervenções concluídas)
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="historico-section">
      <div class="historico-header">
        <div>
          <h3>Histórico de manutenção</h3>
          <p>Intervenções concluídas nesta viatura.</p>
        </div>
        <button
          type="button"
          class="btn-web-primary"
          (click)="openCreate()"
          [disabled]="isEquipamentoInativo()"
          [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : ''"
          tooltipPosition="top"
        >
          <i class="ri-add-line"></i> Nova manutenção
        </button>
      </div>

      <!-- TIMELINE -->
      <div class="maintenance-timeline" *ngIf="historicoConcluidas.length > 0">
        <div
          class="timeline-item"
          *ngFor="let row of historicoConcluidas; let last = last"
          [class.is-last]="last"
        >
          <div class="timeline-marker">
            <span class="marker-dot"></span>
            <span class="marker-line" *ngIf="!last"></span>
          </div>

          <div class="timeline-content">
            <div class="tc-header">
              <strong class="tc-title">{{ getTimelineTitle(row) }}</strong>
              <span class="tc-date">{{ formatDate(row.dataManutencao) }}</span>
            </div>

            <div class="tc-details">
              <span class="tc-desc" *ngIf="row.descricaoServico">
                {{ row.descricaoServico }}
              </span>
              <span class="tc-meta">
                <span class="tc-cost" *ngIf="row.custo != null">
                  {{ formatKz(row.custo) }}
                </span>
                <span class="tc-dot" *ngIf="getOficina(row)">·</span>
                <span class="tc-oficina" *ngIf="getOficina(row)">
                  <i class="ri-building-line"></i> {{ getOficina(row) }}
                </span>
                <span class="tc-dot" *ngIf="row.quilometragemOuHorasUso">·</span>
                <span class="tc-km" *ngIf="row.quilometragemOuHorasUso">
                  {{ row.quilometragemOuHorasUso | number:'1.0-0' }} km
                </span>
              </span>
              <p class="tc-obs" *ngIf="getObservacoesLimpas(row)">
                {{ getObservacoesLimpas(row) }}
              </p>
            </div>

            <div class="tc-footer">
              <span class="attachment-pill" *ngIf="row.anexos && row.anexos.length > 0">
                <i class="ri-attachment-2"></i> {{ row.anexos.length }} {{ row.anexos.length === 1 ? 'anexo' : 'anexos' }}
              </span>

              <div class="tc-actions">
                <button
                  type="button"
                  class="btn-icon-subtle"
                  (click)="openEdit(row)"
                  [disabled]="isEquipamentoInativo()"
                  [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : 'Editar registo'"
                  tooltipPosition="top"
                >
                  <i class="ri-pencil-line"></i>
                </button>
                <button
                  type="button"
                  class="btn-icon-subtle danger"
                  (click)="confirmDelete(row)"
                  [disabled]="isEquipamentoInativo()"
                  [pTooltip]="isEquipamentoInativo() ? 'Equipamento inativo' : 'Eliminar registo'"
                  tooltipPosition="top"
                >
                  <i class="ri-delete-bin-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- EMPTY STATE HISTÓRICO -->
      <div class="historico-empty" *ngIf="historicoConcluidas.length === 0">
        <div class="he-icon">
          <i class="ri-history-line"></i>
        </div>
        <strong>Sem intervenções concluídas</strong>
        <p>As manutenções concluídas nesta viatura aparecerão aqui no histórico em formato de linha temporal.</p>
      </div>
    </div>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════════════════════
       5. DRAWER DE CONCLUSÃO DE MANUTENÇÃO (Captura Dados Reais)
       ════════════════════════════════════════════════════════════════════════ -->
  <p-drawer
    [(visible)]="concluirDrawerVisible"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    styleClass="maintenance-drawer"
    header="Concluir Intervenção"
    (onHide)="closeConcluirDrawer()"
  >
    <div class="drawer-form-container" *ngIf="concluindoRow">
      <!-- Card informativo da intervenção em conclusão -->
      <div class="concluir-info-card">
        <span class="cic-type">{{ getTipoLabel(concluindoRow.manutencaoTipoEnum) }}</span>
        <strong class="cic-title">{{ concluindoRow.descricaoServico || 'Intervenção #' + concluindoRow.id }}</strong>
        <div class="cic-meta">
          <span>Estimado: {{ formatKz(concluindoRow.custo) }}</span>
          <span *ngIf="concluindoRow.quilometragemOuHorasUso"> · {{ concluindoRow.quilometragemOuHorasUso | number:'1.0-0' }} km</span>
        </div>
      </div>

      <div class="sp-form-grid">
        <!-- Data Real de Conclusão -->
        <div class="sp-form-group">
          <label>Data de Conclusão <span class="required">*</span></label>
          <p-datepicker
            [(ngModel)]="concluirForm.dataConclusao"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            appendTo="body"
            styleClass="w-full"
          />
        </div>

        <!-- Custo Real -->
        <div class="sp-form-group">
          <label>Custo Real (Kz / AOA) <span class="required">*</span></label>
          <p-inputNumber
            [(ngModel)]="concluirForm.custoReal"
            mode="currency"
            currency="AOA"
            locale="pt-AO"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            placeholder="0 Kz"
            styleClass="w-full"
          />
          <small class="field-hint">Pode diferir do valor estimado na abertura.</small>
        </div>

        <!-- Km Real -->
        <div class="sp-form-group">
          <label>Km Real / Horas de Uso</label>
          <p-inputNumber
            [(ngModel)]="concluirForm.kmReal"
            [min]="0"
            placeholder="Ex: 42000"
            styleClass="w-full"
          />
        </div>

        <!-- Oficina / Prestador -->
        <div class="sp-form-group">
          <label>Oficina / Prestador Executante</label>
          <input
            pInputText
            [(ngModel)]="concluirForm.oficina"
            placeholder="Ex: Auto Reparo Luanda, MetalCar..."
            class="w-full"
          />
        </div>

        <!-- Observações Finais -->
        <div class="sp-form-group full-width">
          <label>Observações Finais & Peças Substituídas</label>
          <textarea
            pTextarea
            [(ngModel)]="concluirForm.observacoes"
            rows="3"
            placeholder="Ex: Troca de óleo 5W30, filtro de ar e pastilhas dianteiras."
            class="w-full"
          ></textarea>
        </div>

        <!-- Anexos / Fatura da Oficina -->
        <div class="sp-form-group full-width">
          <label>Fatura da Oficina / Comprovativos</label>
          <div class="file-upload-box">
            <label class="file-upload-trigger">
              <input
                type="file"
                multiple
                (change)="onConcluirFileChange($event)"
                hidden
              />
              <i class="ri-upload-cloud-2-line"></i>
              <span>Adicionar fatura ou relatório em PDF/Imagem</span>
            </label>
            <div class="files-preview-list" *ngIf="concluirSelectedFiles.length">
              <div class="file-chip" *ngFor="let file of concluirSelectedFiles; let i = index">
                <i class="ri-file-text-line"></i>
                <span class="file-name">{{ file.name }}</span>
                <button type="button" (click)="removeConcluirFile(i)">
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="drawer-actions">
        <button
          type="button"
          class="btn-web-secondary"
          (click)="closeConcluirDrawer()"
          [disabled]="savingConclusao"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-web-primary"
          (click)="saveConclusao()"
          [disabled]="savingConclusao || isEquipamentoInativo()"
        >
          <i class="ri-check-double-line"></i>
          {{ savingConclusao ? 'A concluir...' : 'Confirmar Conclusão' }}
        </button>
      </div>
    </div>
  </p-drawer>

  <!-- ════════════════════════════════════════════════════════════════════════
       6. DRAWER DE REGISTO / EDIÇÃO DE MANUTENÇÃO
       ════════════════════════════════════════════════════════════════════════ -->
  <p-drawer
    [(visible)]="drawerVisible"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    styleClass="maintenance-drawer"
    [header]="drawerTitle"
    (onHide)="closeDrawer()"
  >
    <div class="drawer-form-container">
      <div class="sp-form-grid">
        <!-- Seleção de Equipamento (quando aplicável) -->
        <div class="sp-form-group full-width" *ngIf="!equipamentoId && availableEquipamentos.length > 1">
          <label>Equipamento <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.equipamentoId"
            [options]="availableEquipamentos"
            optionLabel="nome"
            optionValue="id"
            placeholder="Selecione um equipamento ativo"
            styleClass="w-full"
          />
        </div>

        <!-- Tipo -->
        <div class="sp-form-group">
          <label>Tipo de Intervenção <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.manutencaoTipoEnum"
            [options]="tipos"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione o tipo"
            styleClass="w-full"
          />
        </div>

        <!-- Estado -->
        <div class="sp-form-group">
          <label>Estado da Intervenção <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.manutencaoEstadoEnum"
            [options]="estados"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione o estado"
            styleClass="w-full"
          />
        </div>

        <!-- Data -->
        <div class="sp-form-group">
          <label>Data Agendada / Início <span class="required">*</span></label>
          <p-datepicker
            [(ngModel)]="form.dataManutencao"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            appendTo="body"
            styleClass="w-full"
          />
        </div>

        <!-- Custo Estimado -->
        <div class="sp-form-group">
          <label>{{ form.manutencaoEstadoEnum === 2 ? 'Custo Real (Kz)' : 'Custo Estimado (Kz)' }}</label>
          <p-inputNumber
            [(ngModel)]="form.custo"
            mode="currency"
            currency="AOA"
            locale="pt-AO"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            placeholder="0 Kz"
            styleClass="w-full"
          />
        </div>

        <!-- Km Previsto -->
        <div class="sp-form-group">
          <label>{{ form.manutencaoEstadoEnum === 2 ? 'Quilometragem Real' : 'Quilometragem Prevista' }}</label>
          <p-inputNumber
            [(ngModel)]="form.quilometragemOuHorasUso"
            [min]="0"
            placeholder="Ex: 50000"
            styleClass="w-full"
          />
        </div>

        <!-- Oficina / Prestador -->
        <div class="sp-form-group">
          <label>Oficina / Prestador</label>
          <input
            pInputText
            [(ngModel)]="formOficina"
            placeholder="Ex: Auto Reparo Luanda, MetalCar..."
            class="w-full"
          />
        </div>

        <!-- Descrição do Serviço -->
        <div class="sp-form-group full-width">
          <label>Descrição do Serviço / Motivo</label>
          <input
            pInputText
            [(ngModel)]="form.descricaoServico"
            placeholder="Ex: Revisão programada, Substituição de pastilhas, Pneu furado..."
            class="w-full"
          />
        </div>

        <!-- Observações -->
        <div class="sp-form-group full-width">
          <label>Observações Detalhadas</label>
          <textarea
            pTextarea
            [(ngModel)]="form.observacoes"
            rows="3"
            placeholder="Notas adicionais sobre o serviço..."
            class="w-full"
          ></textarea>
        </div>

        <!-- Anexos -->
        <div class="sp-form-group full-width">
          <label>Anexos e Documentos</label>
          <div class="file-upload-box">
            <label class="file-upload-trigger">
              <input
                type="file"
                multiple
                (change)="onFileChange($event)"
                hidden
              />
              <i class="ri-upload-cloud-2-line"></i>
              <span>Carregar orçamentos ou comprovativos</span>
            </label>
            <div class="files-preview-list" *ngIf="selectedFiles.length">
              <div class="file-chip" *ngFor="let file of selectedFiles; let i = index">
                <i class="ri-file-text-line"></i>
                <span class="file-name">{{ file.name }}</span>
                <button type="button" (click)="removeFile(i)">
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="drawer-actions">
        <button
          type="button"
          class="btn-web-secondary"
          (click)="closeDrawer()"
          [disabled]="saving"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-web-primary"
          (click)="save()"
          [disabled]="saving || isEquipamentoInativo()"
        >
          <i class="ri-save-line"></i>
          {{ saving ? 'A guardar...' : 'Guardar Manutenção' }}
        </button>
      </div>
    </div>
  </p-drawer>
</section>